export default {"src":"/_next/static/media/logotipo.721d874d.svg","height":43,"width":191,"blurWidth":0,"blurHeight":0};